import React, { ReactNode, useEffect, useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import { useDrawer } from './context/DrawerContext';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomAppBar from './CustomAppbar';
import DrawerMenu from './DrawerMenu';
import Footer from './Footer';
import Header from './Header';

interface WrapperProps {
  children: ReactNode;
}

const drawerWidth = 0;
const collapsedWidth = 0;

const Wrapper: React.FC<WrapperProps> = ({ children }) => {
  const { drawerOpen } = useDrawer();
  const navigate = useNavigate();
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const isInformesRoute = location.pathname.startsWith('/informes/');

  useEffect(() => {
    if (!isInformesRoute) {
      return;
    }

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [isInformesRoute]);

  if (redirect) {
    navigate('login');
  }

  return (
    <Box
      sx={{
        display: 'flex',
        overflowX: 'hidden',
        minHeight: '100vh',
        ...(isInformesRoute ? { height: '100vh', overflowY: 'hidden' } : {}),
      }}
    >
      <CssBaseline />
      <CustomAppBar />
      <DrawerMenu />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          ...(isInformesRoute
            ? {
                height: { xs: 'calc(100vh - 8px)', sm: 'calc(100vh - 8px)' },
                marginTop: { xs: '8px', sm: '8px' },
                boxSizing: 'border-box',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
              }
            : {}),
          transition: (theme) => theme.transitions.create(['padding'], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          paddingLeft: {
            xs: `${collapsedWidth}px`,
            sm: drawerOpen ? `${drawerWidth}px` : `${collapsedWidth}px`,
          },
        }}
      >
        <Header
          sx={isInformesRoute ? { pt: 0, pb: 0.5, px: 0.5 } : undefined}
        >
          {children}
        </Header>
        <Footer />
      </Box>
    </Box>
  );
};

export default Wrapper;
